import { map } from 'ramda';

import { IOfferHelperProps } from '../../types/offer-card';
import { TComputedPropMapper } from '../../types/computed-props-mapper';

import { agentBuildersLabel } from './agentBuildersLabel';
import { agentContactStatus } from './agentContactStatus';
import { agentIcon } from './agentIcon';
import { agentImageLink } from './agentImageLink';
import { agentInfo } from './agentInfo';
import { agentName } from './agentName';
import { agentOffersLink } from './agentOffersLink';
import { agentPhoneWarningMessage } from './agentPhoneWarningMessage';
import { agentProfileLink } from './agentProfileLink';
import { agentWorkTime } from './agentWorkTime';
import { geoExtensionLabel } from './geoExtensionLabel';
import { geoLabels } from './geoLabels';
import { hasVideo } from './hasVideo';
import { isAgent } from './isAgent';
import { isColored } from './isColored';
import { isDealRentCianAgency } from './isDealRentCianAgency';
import { isFromBank } from './agent/isFromBank';
import { isHonestAgent } from './isHonestAgent';
import { isPremium } from './isPremium';
import { isProAgent } from './isProAgent';
import { isTop } from './isTop';
import { jk } from './jk';
import { media } from './media';
import { mediaLabels } from './mediaLabels';
import { price } from './price';
import { priceExtensionLabel } from './priceExtensionLabel';
import { priceInfo } from './priceInfo';
import { railway } from './railway';
import { seoSuggestionDistance } from './seoSuggestionDistance';
import { seoSuggestionLabel } from './seoSuggestionLabel';
import { similarLink } from './similarLink';
import { subtitle } from './subtitle';
import { thumbnails } from './thumbnails';
import { title } from './title';
import { underground } from './underground';
import { vasList } from './vasList';
import { hasTour } from './hasTour';

export const combineComputedProps: TComputedPropMapper<IOfferHelperProps> = (...args) =>
  map(fn => fn(...args), {
    agentBuildersLabel,
    agentContactStatus,
    agentIcon,
    agentImageLink,
    agentInfo,
    agentName,
    agentOffersLink,
    agentPhoneWarningMessage,
    agentProfileLink,
    agentWorkTime,
    geoExtensionLabel,
    geoLabels,
    hasTour,
    hasVideo,
    isAgent,
    isColored,
    isDealRentCianAgency,
    isFromBank,
    isHonestAgent,
    isPremium,
    isProAgent,
    isTop,
    jk,
    media,
    mediaLabels,
    price,
    priceExtensionLabel,
    priceInfo,
    railway,
    seoSuggestionDistance,
    seoSuggestionLabel,
    similarLink,
    subtitle,
    thumbnails,
    title,
    underground,
    vasList,
  });
